/**
 * @file index.tsx
 *
 * @fileoverview Shows information about the organization inside a box.
 */

import React from 'react';
import { OrganizationProfile } from '~/jobiqo/types/types';
import OrganizationInfoBoxWidgetView from '~/jobiqo/components/Organization/Widgets/InfoBox/View';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Box } from '~/vcl/atoms/07-box';
import styles from './infoBox.module.scss';

export const ORG_INFO_WIDGET_KEY = 'info';

export interface OrganizationInfoBoxWidgetProps {
  organization: OrganizationProfile;
  miniSite?: boolean;
}

export const OrganizationInfoBoxWidget = ({
  organization,
  miniSite = false,
}: OrganizationInfoBoxWidgetProps) => {
  const infoBoxClassName = `${styles.infoBox} ${
    miniSite ? styles.miniSiteInfoBox : styles.boxWithMargin
  }`;

  return (
    <Main size={miniSite ? 'xLarge' : 'large'}>
      <Box
        boxShadow={miniSite ? 'none' : undefined}
        borderRadius={miniSite ? '0' : undefined}
        className={infoBoxClassName}
      >
        <OrganizationInfoBoxWidgetView
          organization={organization}
          boxId={ORG_INFO_WIDGET_KEY}
        />
      </Box>
    </Main>
  );
};
export default OrganizationInfoBoxWidget;
